const timelineViewStyles = () => ({
    timelineContainer: {
        position: 'relative',
        paddingLeft: 48,
    },

    timelineItem: {
        position: 'relative',
        paddingBottom: 36,
    },

    timelineItemLast: {
        paddingBottom: 0,
    },

    verticalLine: {
        position: 'absolute',
        left: -20,
        width: 2,
        height: 'calc(100% + 16px)',
    },

    verticalLineCancelled: {
        backgroundColor: '#CF1322',
    },

    verticalLinePending: {
        backgroundColor: '#D9D9D9',
    },

    verticalLineAchieved: {
        backgroundColor: '#33C658',
    },

    timelineRow: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: 28,
    },

    planeIconWrapper: {
        position: 'absolute',
        left: -34,
        width: 30,
        height: 30,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },

    planeIcon: {
        width: 20,
        height: 20,
    },

    statusIconWrapper: {
        position: 'absolute',
        left: -40,
        width: 16.67,
        height: 16.67,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginLeft: -8.335,
    },

    statusIconWrapperCancelled: {
        color: '#CF1322',
    },

    statusIconWrapperAchieved: {
        color: '#33C658',
    },

    statusIcon: {
        fontSize: 16.67,
        color: 'inherit',
    },

    statusDotCurrent: {
        width: 11.67,
        height: 11.67,
        borderRadius: '50%',
        border: '2px solid #0052CC',
    },

    statusDotPending: {
        width: 11.67,
        height: 11.67,
        borderRadius: '50%',
        backgroundColor: '#E5E6EA',
    },

    contentContainer: {
        flex: 1,
    },

    statusHeader: {
        color: 'black',
        fontSize: 14,
        fontFamily: 'Open Sans',
        fontWeight: 600,
        marginBottom: 2,
        display: 'flex',
        justifyContent: 'space-between',
    },

    statusHeaderInactive: {
        opacity: 0.5,
    },

    expandToggle: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        cursor: 'pointer',
        color: 'rgba(0, 0, 0, 0.60)',
        fontSize: 14,
        fontWeight: 600,
        marginTop: 8,
    },

    expandToggleIcon: {
        fontSize: 12,
        transition: 'transform 0.3s',
    },

    expandToggleIconExpanded: {
        transform: 'rotate(180deg)',
    },

    latestEventTitle: {
        color: 'rgba(0, 0, 0, 0.40)',
        fontSize: 14,
        fontFamily: 'Open Sans',
        fontWeight: 600,
    },

    latestEventDate: {
        color: 'rgba(0, 0, 0, 0.40)',
        fontSize: 12,
        fontFamily: 'Open Sans',
        fontWeight: 600,
        marginBottom: 8,
    },

    latestEventDateNoMargin: {
        marginBottom: 0,
    },

    expandedEventsContainer: {
        marginTop: 12,
        padding: 16,
        background: '#F5F5F5',
        borderRadius: 6,
    },

    eddText: {
        color: 'rgba(0, 0, 0, 0.60)',
        fontSize: 13,
        fontFamily: 'Open Sans',
        fontWeight: 600,
        marginTop: 8,
    },

    detailsContainer: {
        marginBottom: 12,
        paddingLeft: 16,
    },

    detailsTrackingNote: {
        color: '#000000',
        fontSize: 12,
        fontWeight: 600,
        marginBottom: 2,
    },

    detailsLocation: {
        color: 'rgba(0, 0, 0, 0.40)',
        fontSize: 12,
        fontWeight: 400,
        marginBottom: 2,
    },

    detailsDateTime: {
        color: 'rgba(0, 0, 0, 0.40)',
        fontSize: 12,
        fontWeight: 600,
        marginBottom: 8,
    },

    detailsFailureReason: {
        color: '#CF1322',
        fontSize: 12,
        fontWeight: 600,
        marginBottom: 4,
    },

    detailsLinkWrapper: {
        marginBottom: 4,
    },

    detailsLink: {
        color: '#165ACE',
        fontSize: 13,
        fontWeight: 600,
        cursor: 'pointer',
    },

    otpText: {
        color: 'rgba(0, 0, 0, 0.40)',
        fontSize: 13,
        fontFamily: 'Open Sans',
        fontWeight: 400,
    },
});

export { timelineViewStyles };
